import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type { TGetCashFlowReportRequest, TGetCashFlowReportResponse } from '/src/lib/types';

export class CashFlowService {
  /**
   * Formats/calculates CashFlow response data
   */
  private static _interceptor = (cashflow: any) => {
    for (let i = 0, il = cashflow.byDate.length; i < il; i += 1) {
      cashflow.byDate[i] = {
        month: cashflow.byDate[i].date,
      };

      cashflow.byDate[i].advances = {
        payments: cashflow.byDate[i].payments,
        advances: cashflow.byDate[i].advances,
      };
    }

    return cashflow.advances;
  };

  /**
   * Get Cash Flow report
   */
  public static async get(req: TGetCashFlowReportRequest): CancelablePromise<TGetCashFlowReportResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/cashflow',
        query: req,
      })
    );
  }
}
